import type { Subscription as BaseSubscription } from '@trustoo/types/entity/subscription'

export interface ServiceEntity {
    service_id: number
    name: string
    url: string
    release_date: string | null
    visible: boolean
    name_provider: string
    name_providers: string
    price_unit: string | null
    enable_profile_projects: boolean
    enable_opening_hours: boolean
    enable_calendar: boolean
    enable_month_picker: boolean
    premium_promo_leads: number
    show_hidden_filters: string | null
    enable_profile_prices: boolean
    services_visible_regions: number[]
    profile_incentives: number[]
    questions: number[]
    highMunicipalityIds: number[]
}

export interface Subscription extends BaseSubscription {
    country_code: string
    service: ServiceEntity
    serviceName: string
    subscriptions_expectation: string | null
    sumPopulation: string
}

export { DEFAULT_MAX_WEEK_PER_SERVICE } from '@trustoo/types/entity/leadSettings'

export const WEEKLY_LIMIT_PER_ACCOUNT = 'per_account'
export const WEEKLY_LIMIT_PER_SERVICE = 'per_service'

export interface LeadServiceSettings {
    service_id: number
    subscription_id: number
    service_provider_id: number
    max_week: number
    week_limit_reached?: string | null
}
